<template>
	<div class="profile_balance">
		<div class="profile_balance-item">
			Balance: <span :class="getClass">$ {{ balance }}</span>
		</div>
		<div class="profile_balance-item">
			Total check: <span>$ {{ totalCheck }}</span> <span>|</span>  Payments: <span>$ {{ payments }}</span>
		</div>
	</div>
</template>

<script>
import getNegativeOrPositiveValue from "@/helper/getNegativeOrPositiveValue";

export default {
	name: "ProfileBalance",
	props: {
		payments: {
			type: Number,
			default: 0
		},
		balance: {
			type: Number,
			default: 0
		},
		totalCheck: {
			type: Number,
			default: 0
		}
	},
	computed: {
		getClass() {
			return getNegativeOrPositiveValue(this.balance);
		}
	}
};
</script>

<style scoped lang="scss">
.profile_balance {
	margin-top: 20px;
	background: var(--card-bg);
	padding: 20px;

	.total {
    color: var(--base-green);
	}

	.totalNegative {
    color: var(--base-red);
	}

	&-item {
		font-weight: 400;
		font-size: 14px;
		line-height: 20px;
		letter-spacing: 0.25px;
		color: var(--card-color);

		&:first-child {
			font-size: 16px;
			margin-bottom: 10px;
		}

		span {
			color: var(--card-color-sub-title);
		}
	}
}
</style>
